import LegalDocumentPage from "@/components/layout/LegalDocumentPage";
import { CONTACT_EMAIL } from "@/config/site";

const LAST_UPDATED = "February 22, 2026";

const sections = [
  {
    title: "1. Policy Statement",
    paragraphs: [
      "Specialist Dental London is committed to handling personal data lawfully, fairly, and transparently. We apply data protection controls across clinical care, referrals, administration, and digital communications.",
    ],
  },
  {
    title: "2. Scope",
    paragraphs: [
      "This policy applies to all personal data processed by the practice, including patient, referrer, supplier, and staff information in paper and electronic formats.",
    ],
  },
  {
    title: "3. Data Protection Principles",
    bullets: [
      "Personal data must be processed lawfully, fairly, and transparently.",
      "Data is collected for specified and legitimate purposes only.",
      "Only relevant and necessary data is processed.",
      "Records are kept accurate and up to date where possible.",
      "Data is retained only for as long as required under legal and clinical obligations.",
      "Appropriate technical and organisational security controls are used at all times.",
      "We maintain accountability for compliance decisions and records.",
    ],
  },
  {
    title: "4. Special Category Health Data",
    paragraphs: [
      "Dental and medical information is special category data and is handled with enhanced safeguards. Access is restricted to authorised personnel with a legitimate clinical or operational need.",
    ],
  },
  {
    title: "5. Roles and Responsibilities",
    paragraphs: [
      "Practice leadership is responsible for data protection governance, policy review, and incident oversight. All staff and contractors must follow confidentiality, security, and lawful processing requirements.",
    ],
  },
  {
    title: "6. Security Controls",
    bullets: [
      "Role-based access and password protection for systems and records.",
      "Secure transfer methods for referral documents and clinical files.",
      "Confidential disposal of records and media.",
      "Operational procedures for incident reporting and response.",
    ],
  },
  {
    title: "7. Data Subject Rights",
    paragraphs: [
      "Individuals may request access, correction, restriction, objection, erasure, or data portability where legally applicable. We respond within statutory timeframes, usually within one calendar month.",
    ],
  },
  {
    title: "8. Data Sharing and Processors",
    paragraphs: [
      "We share personal data only when necessary for treatment, operations, or legal obligations. Third-party processors are selected with due diligence and must provide appropriate security and confidentiality assurances.",
    ],
  },
  {
    title: "9. Personal Data Breaches",
    paragraphs: [
      "Suspected or confirmed data incidents are escalated without delay. Risks are assessed and, where required by law, relevant regulators and affected individuals are notified.",
    ],
  },
  {
    title: "10. Retention and Disposal",
    paragraphs: [
      "Records are retained in line with applicable legal, professional, and insurance requirements. Data is securely archived, anonymised, or destroyed when retention periods expire.",
    ],
  },
  {
    title: "11. Contact",
    paragraphs: [
      `For data protection requests or questions, contact ${CONTACT_EMAIL}. Please provide enough detail for us to verify identity and locate relevant records.`,
    ],
  },
];

export default function DataProtection() {
  return (
    <LegalDocumentPage
      title="Data Protection Policy"
      lastUpdated={LAST_UPDATED}
      intro="This policy explains how we apply UK data protection standards across our practice operations."
      sections={sections}
      testIdPrefix="data-protection"
    />
  );
}
